export const data = {
    en: {
      paragraphs: [
        {
          title: 'Contact details',
          allText: [
            [
                {
                    title: '',
                    text: 'Institut für Berufsbildung Niedersachsen e.V.',
                },
                {
                    title: '',
                    text: 'Hohestr. 9, 30449 Hannover',
                },
                {
                    title: '',
                    text: 'Tel.: 0511 92 40 01 819',
                },
                {
                    title: '',
                    text: 'Fax: 0511 92 40 01 899',
                },
                {
                    title: '',
                    text: 'E-Mail: info@ib-nds.com',
                },
                {
                    title: 'Represented by',
                    text: 'Herr Klaus Bierschenk',
                },
                {
                    title: '',
                    text: 'Frau Minxia, Yan',
                },
            ],
            [
                {
                    title: '',
                    text: 'Hohestr. 9, 30449 Hannover',
                },
                {
                    title: '',
                    text: 'Tel.: 0511 92 40 01 819',
                },
                {
                    title: '',
                    text: 'Fax: 0511 92 40 01 899',
                },
                {
                    title: '',
                    text: 'The imprint applies to www.ib-nds.de',
                },
                {
                    title: '',
                    text: 'Registered under: Registergericht: Amtgericht Hannover, VR 202828',
                },
            ]
          ]
        },
      ],
    },
    de: {
      paragraphs: [
        {
          title: 'Kontaktdaten',
          allText: [
                [
                    {
                        title: '',
                        text: 'Institut für Berufsbildung Niedersachsen e.V.',
                    },
                    {
                        title: '',
                        text: 'Hohestr. 9, 30449 Hannover',
                    },
                    {
                        title: '',
                        text: 'Tel.: 0511 92 40 01 819 ',
                    },
                    {
                        title: '',
                        text: 'Fax: 0511 92 40 01 899',
                    },
                    {
                        title: '',
                        text: 'E-Mail: info@ib-nds.com',
                    },
                    {
                        title: 'Vertreten durch',
                        text: 'Herr Klaus Bierschenk',
                    },
                    {
                        title: '',
                        text: 'Frau Minxia, Yan',
                    },
                ],
                [
                    {
                        title: '',
                        text: 'Hohestr. 9, 30449 Hannover',
                    },
                    {
                        title: '',
                        text: 'Tel.: 0511 92 40 01 819',
                    },
                    {
                        title: '',
                        text: 'Fax: 0511 92 40 01 899',
                    },
                    {
                        title: '',
                        text: 'Das Impressum gilt für www.ib-nds.de',
                    },
                    {
                        title: '',
                        text: 'Registriert unter: Registergericht: Amtgericht Hannover, VR 202828',
                    },
                ]
            ]
        },
      ],
    },
};